import React from 'react';
import { Box, Paper, Skeleton, Stack } from '@mui/material';

/** Shimmering placeholder shaped like `RootCausePanel`, for the same reason
 * `ChainViewSkeleton` exists — preview the final shape while data loads. */
export default function RootCausePanelSkeleton() {
  return (
    <Paper variant="outlined" sx={(t) => ({ borderRadius: `${t.ds?.radius?.md ?? 8}px`, overflow: 'hidden' })}>
      <Box sx={(t) => ({ px: 2, py: 1.25, borderBottom: `1px solid ${t.tokens.border.subtle}`, bgcolor: t.tokens.surface.sunken })}>
        <Skeleton variant="text" animation="wave" width="35%" height={22} />
      </Box>
      <Stack spacing={1.5} sx={{ p: 2.5 }}>
        <Stack spacing={0.5}>
          <Skeleton variant="text" animation="wave" width="20%" />
          <Skeleton variant="text" animation="wave" width="95%" />
          <Skeleton variant="text" animation="wave" width="80%" />
        </Stack>
        <Stack spacing={0.5}>
          <Skeleton variant="text" animation="wave" width="15%" />
          <Skeleton variant="text" animation="wave" width="90%" />
          <Skeleton variant="text" animation="wave" width="70%" />
        </Stack>
        <Skeleton variant="rounded" animation="wave" height={48} />
      </Stack>
    </Paper>
  );
}
